import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { limitSet } from "../../features/filter/filterSlice";

export const selectOptions = [
  { value: 4, label: "Limit: 4" },
  { value: 8, label: "Limit: 8" },
  { value: 12, label: "Limit: 12" },
  { value: 16, label: "Limit: 16" },
  { value: 20, label: "Limit: 20" },
  { value: 24, label: "Limit: 24" },
  { value: 28, label: "Limit: 28" },
];

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    width: "5.9rem",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    display: "none",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    textAlign: "center",
    fontWeight: 600,
    background: "#E5E7EB",
  }),
  input: (provided, state) => ({
    ...provided,
    justifyContent: "center",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#4B5563",
  }),
  menuList: (provided, state) => ({
    ...provided,
    textAlign: "center",
  }),
};

const SelectLimit = () => {
  const [limitLocal, setLimitLocal] = useState();
  const dispatch = useDispatch();
  const { limit: currentLimit } = useSelector((state) => state.filter);

  const handleChange = (newValue) => {
    const newLimit = parseInt(newValue?.value);
    if (newLimit > 3) {
      newValue.label = `Limit: ${newLimit}`;
      dispatch(limitSet(newLimit));
    }
  };

  useEffect(
    () =>
      setLimitLocal({ value: currentLimit, label: `Limit: ${currentLimit}` }),
    [currentLimit]
  );

  return (
    <div>
      <CreatableSelect
        onChange={handleChange}
        options={selectOptions}
        styles={customStyles}
        value={limitLocal}
      />
    </div>
  );
};

export default SelectLimit;
